<div class="partners-container">
  <raf-image  class="partner-item m-3" *ngFor="let partner of data?.partners" [fromCms]="partner.image?.data?.attributes"></raf-image>
</div>

<div class="partners-container mt-5">
  <a mat-stroked-button data-cy="partners-article-button" class="mat-small" type="button" [href]="data?.articleUrl">{{data?.title}}</a>
</div>


